<p
    #elm
    class="{{ size }}"
    class="price"
    [ngClass]="{
        'is-main-price': isMainPrice,
        'has-description': hasIcon,
        'has-text-grey-dark': isDiscountPrice,
        'is-greyed': isDiscountPrice,
        strike: isDiscountPrice,
        'has-text-weight-normal': inheritFontSize,
        'has-text-weight-bold': isBold,
    }"
>
    <span [ngClass]="{ main: !isInlined }">
        @if (isAdditionalPrice) {
            <span>+</span>
        }
        <span>{{ mainPrice }}{{ centimePrice && isInlined ? ',' : '' }}</span>
    </span>
    <span [ngClass]="{ 'price-details': !isInlined }">
        <span [ngClass]="{ cents: !isInlined }">
            <span>
                @if (!isInlined) {
                    <span>€{{ centimePrice }}</span>
                }
                @if (isInlined) {
                    <span>{{ centimePrice }} €</span>
                }
                @if (isWithoutTax && isInlined) {
                    <span>HT</span>
                }
                @if ((isWithoutTax && !isInlined) || asterix) {
                    <sup>{{ isWithoutTax && !isInlined ? 'HT' : '' }} {{ asterix ? '(' + asterix + ')' : '' }}</sup>
                }
            </span>
            @if (hasIcon) {
                <span class="icon">
                    <span [ngClass]="iconClassNames" (click)="clickIcon()"></span>
                </span>
            }
        </span>
        @if (hasPeriod) {
            <span class="period">/mois</span>
        }
    </span>
</p>
